__turbopack_context__.v({
  "active": "Dropdown-module-scss-module__-5MZxq__active",
  "calc_chosedProgram": "Dropdown-module-scss-module__-5MZxq__calc_chosedProgram",
  "calc_dropdown": "Dropdown-module-scss-module__-5MZxq__calc_dropdown",
  "calc_programs": "Dropdown-module-scss-module__-5MZxq__calc_programs",
  "calc_programs_item": "Dropdown-module-scss-module__-5MZxq__calc_programs_item",
  "calc_svgArrows": "Dropdown-module-scss-module__-5MZxq__calc_svgArrows",
  "calc_svgRotate": "Dropdown-module-scss-module__-5MZxq__calc_svgRotate",
  "disabled": "Dropdown-module-scss-module__-5MZxq__disabled",
});
